import React, { ReactElement, ReactNode } from "react"
import Icon from "components/elements/Icon"
import { Box } from "@chakra-ui/react"
import NavLink from "../NavLink"

type Props = {
  icon: string | ReactElement;
  title: string;
  // Without a path, a button: an item that opens something rather than a page
  path?: string;
  compact?: boolean;
  showSubMenu?: boolean;
  type?: "account" | "event";
  onClick?: (event: React.MouseEvent) => void;
  indicator?: ReactNode;
  children?: ReactNode | ReactNode[];
} & Pick<React.HTMLAttributes<HTMLElement>, "aria-label" | "onMouseEnter" | "onFocus">

const NavItem = ({
  icon,
  title,
  path,
  compact,
  showSubMenu,
  children,
  type = "account",
  indicator,
  ...props
}: Props) => {
  const submenu = children && (
    <Box
      my={1}
      {...showSubMenu ? { display: "block" } : { display: "none" }}
    >
      {children}
    </Box>
  )

  const itemProps = {
    display: "block",
    borderLeftWidth: 5,
    borderColor: "gray.900",
    lineHeight: "taller",
    letterSpacing: ".05em",
    ...type === "account" ? { px: compact ? 5 : 8 } : {
      px: 5, pt: 2, pb: 1, fontSize: "sm",
    },
  }
  const iconSpacing = { mr: type === "account" ? 1 : 4, mb: 1, verticalAlign: "middle" }
  const content = (
    <Box>
      {typeof icon === "string"
        ? <Icon icon={icon} size={5} {...iconSpacing} />
        : <Box as="span" display="inline-block" {...iconSpacing}>{icon}</Box>}
      {" "}{!compact && title}
    </Box>
  )

  return (
    <Box position="relative" pb={type === "account" ? 10 : 2}>
      {path ? (
        <NavLink
          activeProps={{
            bg: "black", borderColor: "blue.500", fontWeight: "bold", color: "white",
          }}
          {...itemProps}
          to={path}
          exact={!!children}
          {...props}
        >
          {content}
        </NavLink>
      ) : (
        <Box as="button" type="button" w="full" textAlign="left" {...itemProps} {...props}>
          {content}
        </Box>
      )}
      {submenu}
      {!compact && indicator}
    </Box>
  )
}

export default NavItem
